import { useState } from 'react';
import { Text, as } from 'folds';
import classNames from 'classnames';
import type { MatrixClient } from '$types/matrix-sdk';
import { sizedIcon, Warning } from '$components/icons/phosphor';
import { ReactionMedia } from '$components/message';
import { mxcUrlToHttp } from '$utils/matrix';
import { useRenderableMediaUrl } from '$hooks/useRenderableMediaUrl';
import * as css from './ReactionViewerMenuItem.css';

export type ReactionViewerMenuItemProps = {
  mx: MatrixClient;
  reaction: string;
  count: number;
  useAuthentication?: boolean;
};

export const ReactionViewerMenuItem = as<'button', ReactionViewerMenuItemProps>(
  ({ className, mx, reaction, count, useAuthentication, ...props }, ref) => {
    const [imgError, setImgError] = useState(false);
    const isCustom = reaction.startsWith('mxc://');
    const rawUrl = isCustom
      ? (mxcUrlToHttp(mx, reaction, useAuthentication) ?? undefined)
      : undefined;
    const renderableUrl = useRenderableMediaUrl(rawUrl);

    const customEmoji =
      imgError || !renderableUrl ? (
        <span title="Failed to load emoji image" aria-label="Failed to load emoji image">
          {sizedIcon(Warning, '100', { style: { opacity: 0.5 } })}
        </span>
      ) : (
        <ReactionMedia src={renderableUrl}>
          <img
            className={css.EmojiImg}
            src={renderableUrl}
            alt={reaction}
            onError={() => setImgError(true)}
          />
        </ReactionMedia>
      );

    return (
      <button type="button" className={classNames(css.MenuItem, className)} {...props} ref={ref}>
        <Text className={css.Emoji} as="span">
          {isCustom ? customEmoji : reaction}
        </Text>
        <span className={css.Count}>{count}</span>
      </button>
    );
  }
);
